import Home from "./Home"
import HoldingPage from "./HoldingPage";
import DivPage from "./DivPage";
import ConfigPage from "./ConfigPage";
import TaxPage from "./TaxPage";
import HistoryPage from "./HistoryPage";
import DivCalendars from "./DivCalendars";
import SectorPage from "./SectorPage";
import DivHistory from "./DivHistory";
import FixedPage from "./FixedPage";
import SummaryPage from "./SummaryPage";
import { usePath } from "../libs/path/PathProvider";

export default function Content(){
    const {path} = usePath();
    switch(path){
    case "/summary":    return <SummaryPage/>
    case "/holding":    return <HoldingPage/>
    case "/fixed":      return <FixedPage/>
    case "/dividend":   return <DivPage/>
    case "/calendar":   return <DivCalendars/>
    case "/config":     return <ConfigPage/>
    case "/tax":        return <TaxPage/>
    case "/history":    return <HistoryPage/>
    case "/sector":     return <SectorPage/>
    case "/divhist":    return <DivHistory/>
    default:            return <Home/>
    }
}